import { useState, useEffect } from "react";

import { fetchUserBanner, clearUserBanner } from "../../api";
import { Banner } from "../../api/types";

/**
 * Hook to get the user banner data if present, or null if not.
 */
export function useUserBanner(): { banner: Banner | null; clearBanner: () => void } {
  const [banner, setBanner] = useState<Banner | null>(null);

  useEffect(() => {
    const loadBanner = async () => {
      const bannerData = await fetchUserBanner();
      setBanner(bannerData ?? null);
    };
    loadBanner();
  }, []);

  const clearBanner = () => {
    if (banner?.id) {
      clearUserBanner(banner.id);
    }
    setBanner(null);
  };

  return { banner, clearBanner };
}
